import { render, staticRenderFns } from "./TagsHeader.vue?vue&type=template&id=7c3d4da8"
import script from "./TagsHeader.vue?vue&type=script&lang=js"
export * from "./TagsHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports